import React, { useEffect, useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {
  AppBar,
  Button,
  Grid,
  Paper,
  Toolbar,
  Typography,
} from '@material-ui/core';
import WeekDaysSelection from './WeekDaysSelection';
import RoutineDaysWeekSelection from './RoutineDaysWeekSelection';
import ZoneListItem from './ZoneListItem';
import Checkbox from '@material-ui/core/Checkbox';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  clearAll,
  getBaseOperationHours,
  getBaseOperationHoursPermission,
  setBaseOperationHours,
  setOperationHour,
} from '../../redux/actions/operationHoursActions';
import {
  getRoutineDays,
  setEdited,
  setEditedRoutineDays,
  setRoutineDays,
  setRestaurantsRoutineDays
} from '../../redux/actions/routineDaysActions';
import { useParams } from 'react-router-dom';
import { selectHoursConverted } from '../../redux/selectors/regionsSelector';
import { arrivalTimes, times as dropdownTimes } from '../../utils/utils';
import { snackbarShowMessage } from '../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';
import { calculateDeliveryTimeBase } from '../../utils/helpers';
import moment from 'moment';
import { operationHoursPermission, otherBasePermission } from './constants/OperationHoursPermission';
import RBISuccessPopup from '../RBIMessagePopup/RBISuccessPopup';
import ShowErrorMessageModal from './RestaurantDetails/ShowErrorMessageModal'

const varToString = varObj => Object.keys(varObj)[0];
const hourNames = ['drIsOpened24Hours', 'dtIsOpened24Hours', 'dhIsOpened24Hours'];
const closeNames = ['drIsClosed', 'dtIsClosed'];

function BaseAdjustment({ classes }: any) {
  const matches = useMediaQuery('(min-width:1280px)');
  const [checkedAllTF, setCheckedAllTF] = useState<boolean>(false);
  const weekDays = useSelector(
    (state: RootStateOrAny) => state.OperationHoursReducer.weekDays,
  );
  const { deliveryDays } = useSelector(
    (state: RootStateOrAny) => state.RoutineDaysReducer,
  );
  const isEdited = useSelector(
    (state: RootStateOrAny) => state.RoutineDaysReducer.edited,
  );
  interface ParamTypes {
    id: string;
  }
  const { id } = useParams<ParamTypes>();
  const [checkedAllClose, setCheckedAllClose] = useState<boolean>(false);
  const [enableBtnEdited, setEnableBtnEdited] = useState<boolean>(true);
  const [successPopupModal, setSuccessPopupModal] = useState({
    isOpen: false,
    message: ''
  });
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [uploadErrors, setErrors] = useState()
  const dispatch: any = useDispatch();

  //Pulling times from redux
  const {
    deliveryTimeOpen,
    deliveryTimeClose,
    drTimeOpen,
    drTimeClose,
    drIsOpened24Hours = 'N',
    drIsClosed = 'N',
    dtTimeOpen,
    dtTimeClose,
    dtIsOpened24Hours = 'N',
    dtIsClosed,
    dhIsOpened24Hours = 'N',
    cateringTimeOpen,
    cateringTimeClose,
    curbsideTimeOpen,
    curbsideTimeClose,
    breakfastTimeOpen,
    breakfastTimeClose,
    lunchTimeOpen,
    lunchTimeClose,
    snackTimeOpen,
    snackTimeClose,
    dinnerTimeOpen,
    dinnerTimeClose,
    lateNightTimeOpen,
    lateNightTimeClose,
    deliveryTimeOpenMode,
    deliveryTimeCloseMode,
    drTimeOpenMode,
    drTimeCloseMode,
    dtTimeOpenMode,
    dtTimeCloseMode,
    cateringTimeOpenMode,
    cateringTimeCloseMode,
    curbsideTimeOpenMode,
    curbsideTimeCloseMode,
    breakfastTimeOpenMode,
    breakfastTimeCloseMode,
    lunchTimeOpenMode,
    lunchTimeCloseMode,
    snackTimeOpenMode,
    snackTimeCloseMode,
    dinnerTimeOpenMode,
    dinnerTimeCloseMode,
    lateNightTimeOpenMode,
    lateNightTimeCloseMode,
    isCalculated = 'N',
    arrivalTime,
    departureTime
  } = useSelector(
    (state: RootStateOrAny) => state.OperationHoursReducer.entity,
  );

  const restaurantServices = useSelector(
    (state: RootStateOrAny) => state.ServicesReducer.entities,
  );

  const { hasEditHoursOfOperation, hasViewMenuItemOperationHours } = useSelector(
    (state: RootStateOrAny) => state.UserReducer.thisUser
  );
  const hasEditPermission = id ? hasEditHoursOfOperation : hasViewMenuItemOperationHours;

  const { selectedRestaurantsList: selectedRestaurants } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer,
  );

  const curbsideService = restaurantServices.find(elem => elem.code === "curbsidePickup");
  const cateringService = restaurantServices.find(elem => elem.code === "catering");
  const driveThruService = restaurantServices.find(elem => elem.code === "driveThru");
  const { deliveryHours } = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );

  const { entity } = useSelector(
    (state: RootStateOrAny) => state.OperationHoursReducer,
  );

  const { Region, Country, CountryId } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );

  const [checkedCB, setCheckedCB] = useState<string[]>(['N', 'N', 'N']);

  const [checkedClose, setCheckedClose] = useState<string[]>(['N', 'N']);

  useEffect(() => {
    if ((brand === 'BK' && Region === 'NA' && Country === 'Canada' && CountryId === 36) || (brand === 'BK' && !id)) {
      setCheckedCB([drIsOpened24Hours, dtIsOpened24Hours, dhIsOpened24Hours]);
    } else {
      setCheckedCB([drIsOpened24Hours, dtIsOpened24Hours]);
    }
    setCheckedClose([drIsClosed, dtIsClosed]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drIsOpened24Hours, dtIsOpened24Hours, dhIsOpened24Hours, drIsClosed, dtIsClosed]);

  //this whole following thing is patched until the right us comes up
  const { restaurant, dayOfWeek, ...treatedPayload } = entity;
  const treatedHours: any = selectHoursConverted(treatedPayload);
  const brand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  let finalPayload: any;

  useEffect(() => {
    finalPayload = {
      ...treatedHours,
      weekDays,
    };
  }, [brand, treatedHours, weekDays]);

  const handleSuccessCloseModal = () => {
    setSuccessPopupModal({
      isOpen: false,
      message: ''
    });
  }

  const handleEditionSubmit = async (e: React.MouseEvent) => {
    //Object that will be sent to the redux action to change everything hours / if is open 24 or closed must be here
    const request = { ...finalPayload, weekDays };

    const validateRequest = function (request, name, msj) {
      if (
        request[`${name}TimeOpen`] === null ||
        request[`${name}TimeClose`] === null
      ) {
        if (
          request[`${name}TimeOpen`] === null &&
          request[`${name}TimeClose`] === null
        ) {
          return true;
        } else {
          dispatch(
            snackbarShowMessage(
              t('operationHours.pairMandatory') + " " + msj,
            ),
          );
          return false;
        }
      }
    };

    const validation = [
      validateRequest(request, 'dr', t('operationHours.diningRoom')),
      validateRequest(request, 'breakfast', t('operationHours.breakfastTime')),
      validateRequest(request, 'lunch', t('operationHours.lunchTime')),
      validateRequest(request, 'snack', t('operationHours.snackTime')),
      validateRequest(request, 'dinner', t('operationHours.dinnerTime')),
      validateRequest(request, 'lateNight', t('operationHours.lateNight')),
    ];

    if (curbsideService && curbsideService.value) {
      validation.splice(2, 0, validateRequest(request, 'curbside', t('operationHours.curbsideTime')));
    }

    if (cateringService && cateringService.value) {
      validation.splice(2, 0, validateRequest(request, 'catering', t('operationHours.cateringTime')));
    }

    if(driveThruService && driveThruService.value){
      validation.splice(2, 0, validateRequest(request, 'dt', t('operationHours.driveThru')),);
    }

    if (validation.includes(false)) {
      return;
    }

    if (!arrivalTime && !checkedAllClose) {
      dispatch(
        snackbarShowMessage(
          t('operationHours.arrivalTimeMandatory'),
        ),
      );
      return;
    }
    
    if (!departureTime && !checkedAllClose && (brand === 'TH' && Region === 'NA')) {
      dispatch(
        snackbarShowMessage(
          t('operationHours.DepartureTimeMandatory'),
        ),
      );
      return;
    }
    else if (brand === 'TH' && (Region === 'NA' || !id)) {
      request.departureTime = departureTime ? departureTime.trim() : null;
    }
    
    if (!drTimeOpen && (drIsClosed === 'N' || !drIsClosed) && (drIsOpened24Hours === 'N' || !drIsOpened24Hours)) {
      dispatch(
        snackbarShowMessage(
          t('operationHours.diningRoomTimeMandatory'),
        ),
      );
      return;
    }
    if (request.drIsOpened24Hours === 'Y') {
      request.drTimeOpen = '00:00';
      request.drTimeClose = '23:59';
    }

    if (driveThruService && driveThruService.value) {
      if (id && !dtTimeOpen && (dtIsClosed === 'N' || !dtIsClosed) && (dtIsOpened24Hours === 'N' || !dtIsOpened24Hours)) {
        dispatch(
          snackbarShowMessage(
            t('operationHours.driveThruTimeMandatory'),
          ),
        );
        return;
      }

      if (request.dtIsOpened24Hours === 'Y') {
        request.dtTimeOpen = '00:00';
        request.dtTimeClose = '23:59';
      }
    }else {
      delete request.dtIsOpened24Hours;
      delete request.dtIsClosed;
      delete request.dtTimeOpen;
      delete request.dtTimeClose;
     }

    if ((isCalculated === 'N' && request.dhIsOpened24Hours === 'Y' && brand === 'BK' && ((Region === 'NA' && Country === 'Canada' && CountryId === 36) || !id))) {
      request.deliveryTimeOpen = '00:00';
      request.deliveryTimeClose = '23:59';
    }
    if (!(brand === 'BK' && Region === 'NA' && Country === 'Canada' && CountryId === 36) && !(brand === 'BK' && !id)) {
      delete request.dhIsOpened24Hours;
    }

    if (isCalculated === 'Y') {
      delete request.deliveryTimeOpen;
      delete request.deliveryTimeClose;
    } else {
      if (
        !(
          Array.isArray(deliveryTimeOpenMode) &&
          deliveryTimeOpenMode.includes('read')
        )
      ) {
        delete request.deliveryTimeOpen;
      }
      if (
        !(
          Array.isArray(deliveryTimeCloseMode) &&
          deliveryTimeCloseMode.includes('read')
        )
      ) {
        delete request.deliveryTimeClose;
      }
    }

    if (cateringService && cateringService.value) {
      if (id && !(cateringTimeOpen && cateringTimeClose) &&
        ((!checkedAllClose && brand === 'TH') || brand !== 'TH')) {
        dispatch(
          snackbarShowMessage(
            t('operationHours.cateringMandatory'),
          ),
        );
        return;
      }
    } else {
      delete request.cateringTimeOpen;
      delete request.cateringTimeClose;
    }

    if (curbsideService && curbsideService.value) {
      if (id && !(curbsideTimeOpen && curbsideTimeClose) &&
        ((!checkedAllClose && brand === 'TH') || brand !== 'TH')) {
        dispatch(
          snackbarShowMessage(
            t('operationHours.curbsideMandatory'),
          ),
        );
        return;
      }
    } else {
      delete request.curbsideTimeOpen;
      delete request.curbsideTimeClose;
    }

    if (
      !(
        Array.isArray(breakfastTimeOpenMode) &&
        breakfastTimeOpenMode.includes('write')
      )
    ) {
      delete request.breakfastTimeOpen;
    }
    if (
      !(
        Array.isArray(breakfastTimeCloseMode) &&
        breakfastTimeCloseMode.includes('write')
      )
    ) {
      delete request.breakfastTimeClose;
    }

    if (
      !(Array.isArray(lunchTimeOpenMode) && lunchTimeOpenMode.includes('write'))
    ) {
      delete request.lunchTimeOpen;
    }
    if (
      !(
        Array.isArray(lunchTimeCloseMode) &&
        lunchTimeCloseMode.includes('write')
      )
    ) {
      delete request.lunchTimeClose;
    }

    if (
      !(Array.isArray(snackTimeOpenMode) && snackTimeOpenMode.includes('write'))
    ) {
      delete request.snackTimeOpen;
    }
    if (
      !(
        Array.isArray(snackTimeCloseMode) &&
        snackTimeCloseMode.includes('write')
      )
    ) {
      delete request.snackTimeClose;
    }

    if (
      !(
        Array.isArray(dinnerTimeOpenMode) &&
        dinnerTimeOpenMode.includes('write')
      )
    ) {
      delete request.dinnerTimeOpen;
    }
    if (
      !(
        Array.isArray(dinnerTimeCloseMode) &&
        dinnerTimeCloseMode.includes('write')
      )
    ) {
      delete request.dinnerTimeClose;
    }

    if (
      !(
        Array.isArray(lateNightTimeOpenMode) &&
        lateNightTimeOpenMode.includes('write')
      )
    ) {
      delete request.lateNightTimeOpen;
    }
    if (
      !(
        Array.isArray(lateNightTimeCloseMode) &&
        lateNightTimeCloseMode.includes('write')
      )
    ) {
      delete request.lateNightTimeClose;
    }

    let body = {
      setting: 'base',
      ...request,
    }
    if (!id) {
      const restaurants = selectedRestaurants.map(
        restaurant => restaurant.metas?.restaurantId,
      );
      body.isCalculated = 'N'
      body = {
        data: body,
        restaurants
      }
    }
    try {
      const OHResult = await dispatch(setBaseOperationHours(id ? id : 'massUpload', body));

      if (deliveryDays.length) {
        let RDResult;
        if (!id) {
          const restaurants = selectedRestaurants.map(
            restaurant => restaurant.metas?.restaurantId,
          )
          const jsonData = {
            data: {
              deliveryDays: deliveryDays
            },
            restaurants: restaurants
          }
          RDResult = await dispatch(setRestaurantsRoutineDays(jsonData));
        } else {
          RDResult = await dispatch(setRoutineDays(id, deliveryDays));
        }
        if (RDResult.status < 300) {
          if (id) {
            dispatch(
              snackbarShowMessage(`Delivery days for restaurant: ${id} edited `),
            );
          } else {
            setSuccessPopupModal({
              isOpen: true,
              message: t('operationHours.massUploadFile.success')
            });
          }

        } else {
          if (id) {
            dispatch(
              snackbarShowMessage(
                `Error while editing restaurant: ${id} delivery days `,
              ),
            );
          } else {
            dispatch(
              snackbarShowMessage(
                t('operationHours.massUpload.error'),
              ),
            );
          }

        }
      }

      if (OHResult.status < 300) {
        dispatch(setEdited(false));
        setEnableBtnEdited(false);
        if (id) {
          dispatch(
            snackbarShowMessage(`Operation hours for restaurant: ${id} edited `),
          );
        } else {
          dispatch(clearAll());
          setSuccessPopupModal({
            isOpen: true,
            message: t('operationHours.success.pendingProcess') + ' ' + OHResult?.data?.result?.referenceId
          });
        }

      } else {
        if (id) {
          dispatch(
            snackbarShowMessage(
              `Error while editing restaurant: ${id} operation hours `,
            ),
          );
        } else {
          dispatch(
            snackbarShowMessage(
              t('operationHours.massUpload.error'),
            ),
          );
        }

      }
    }
    catch (error) {
      if (error?.response?.data?.error_code === 'INTERNAL_SERVER_ERROR') {
        setOpenErrorModal(true);
        setErrors(error?.response?.data);
      } else {
        if (id) {
          dispatch(
            snackbarShowMessage(
              `Error while editing restaurant: ${id} operation hours `,
            ),
          );
        } else {
          dispatch(
            snackbarShowMessage(
              t('operationHours.massUpload.error'),
            ),
          );
        }
      }
    }
  };
  const handleEditionCancel = (e: React.MouseEvent) => {
    if (id) {
      dispatch(getBaseOperationHours(id, weekDays));
      dispatch(getRoutineDays(id));
    } else {
      dispatch(clearAll());
      dispatch(setEditedRoutineDays([]));
    }
    dispatch(setEdited(false));
    setEnableBtnEdited(false);
  };

  useEffect(() => {
    if((driveThruService && !driveThruService.value) && (drIsOpened24Hours === 'Y' || drIsClosed === 'Y')){
      if(brand === 'BK' && Region === 'NA' && Country === 'Canada' && CountryId === 36){
        (drIsOpened24Hours === 'Y' && isCalculated === 'N' && dhIsOpened24Hours === 'Y')? setCheckedAllTF(true) : setCheckedAllTF(false);
      }else{
        drIsOpened24Hours === 'Y'? setCheckedAllTF(true) : setCheckedAllTF(false);
      }
      drIsClosed === 'Y'? setCheckedAllClose(true):setCheckedAllClose(false);
    }else{
    setCheckedAllTF(checkedCB.every(el => el === 'Y'));
    setCheckedAllClose(checkedClose.every(el => el === 'Y'));
    }
  }, [checkedCB, finalPayload, checkedClose, driveThruService, drIsOpened24Hours, drIsClosed, brand, Region, Country, CountryId, isCalculated, dhIsOpened24Hours]);

  useEffect(() => {
    return () => {
      dispatch(clearAll());
      dispatch(setEditedRoutineDays([]));
    };
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      var result;
      const fetchData = async () => {
        result = await dispatch(getBaseOperationHours(id, weekDays));
      if (result?.status !== 200) {
          dispatch(
            snackbarShowMessage(
              `Error while fetching information for restaurant # ${id}`,
            ),
          );
        }
      };
      if (weekDays.length) {
        fetchData();
        setEnableBtnEdited(true);
      }

    }
    else {
      dispatch(getBaseOperationHoursPermission({ ...operationHoursPermission, ...otherBasePermission }))
    }
  }, [dispatch, id, weekDays]);

  useEffect(() => {
    if(id){
      dispatch(getRoutineDays(id));
    }
  }, [dispatch, id])

  const handleCheckAllTF = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setEdited(true));
    if (!checkedAllTF) {
      if (brand === 'BK' && ((Region === 'NA' && Country === 'Canada' && CountryId === 36) || !id)) {
        setCheckedCB([...checkedCB.fill('Y', 0, checkedCB.length)]);
        [drIsOpened24Hours, dtIsOpened24Hours, dhIsOpened24Hours].forEach((_, index) =>
          dispatch(
            setOperationHour({
              hourName: hourNames[index],
              hourValue: checkedAllTF ? 'N' : 'Y',
            }),
          ),
        );
      } else {
        setCheckedCB([...checkedCB.fill('Y', 0, checkedCB.length)]);
        [drIsOpened24Hours, dtIsOpened24Hours].forEach((_, index) =>
          dispatch(
            setOperationHour({
              hourName: hourNames[index],
              hourValue: checkedAllTF ? 'N' : 'Y',
            }),
          ),
        );

      }
      setCheckedAllTF(true);
      setCheckedClose([...checkedClose.fill('N', 0, checkedClose.length)]);
      [drIsClosed, dtIsClosed].forEach((_, index) =>
        dispatch(
          setOperationHour({
            hourName: closeNames[index],
            hourValue: 'N',
          }),
        ),
      );
      setCheckedAllClose(false);
    } else if (checkedAllTF) {
      setCheckedCB([...checkedCB.fill('N', 0, checkedCB.length)]);
      [drIsOpened24Hours, dtIsOpened24Hours, dhIsOpened24Hours].forEach((_, index) => {
        return dispatch(
          setOperationHour({
            hourName: hourNames[index],
            hourValue: checkedAllTF ? 'N' : 'Y',
          }),
        );
      });
      setCheckedAllTF(false);
    }
  };

  const handleCheckAllClose = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setEdited(true));
    if (!checkedAllClose) {
      setCheckedClose([...checkedClose.fill('Y', 0, checkedClose.length)]);
      [drIsClosed, dtIsClosed].forEach((_, index) =>
        dispatch(
          setOperationHour({
            hourName: closeNames[index],
            hourValue: checkedAllClose ? 'N' : 'Y',
          }),
        ),
      );
      setCheckedAllClose(true);
      setCheckedCB([...checkedCB.fill('N', 0, checkedCB.length)]);
      [drIsOpened24Hours, dtIsOpened24Hours, dhIsOpened24Hours].forEach((_, index) =>
        dispatch(
          setOperationHour({
            hourName: hourNames[index],
            hourValue: 'N',
          }),
        ),
      );
      setCheckedAllTF(false);
    } else if (checkedAllClose) {
      setCheckedClose([...checkedClose.fill('N', 0, checkedClose.length)]);
      [drIsClosed, dtTimeClose].forEach((_, i) =>
        dispatch(
          setOperationHour({
            hourName: closeNames[i],
            hourValue: checkedAllClose ? 'N' : 'Y',
          }),
        ),
      );
      setCheckedAllClose(false);
    }
  };
  const [deliveryOpen, setDeliveryOpen] = useState<string>('');
  const [deliveryClose, setDeliveryClose] = useState<string>('');
  useEffect(() => {
    // TODO - All BaseAdjustment module needs to be refactor to better code practices.
    // - Decrease the current highly coupled code.
    // - Remove the harcoded catalogs as the times in all components.
    // This hardcoded is temporal to solve BUG 17095
    const specialDrDtTimes = [
      '00:00',
      '00:30',
      '01:00',
      '01:30',
      '02:00',
      '02:30',
      '03:00',
      '03:30',
      '04:00',
      '04:30',
      '05:00',
      '05:30',
      '06:00',
      '06:30',
      '07:00',
      '07:30',
      '08:00',
      '08:30',
      '09:00',
      '09:30',
      '10:00',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
    ];

    let deliveryOpenTemp = '';
    let deliveryCloseTemp = '';
    const dtTimeOpenIndex = dropdownTimes.findIndex(
      elem => elem === dtTimeOpen,
    );
    const drTimeOpenIndex = dropdownTimes.findIndex(
      elem => elem === drTimeOpen,
    );
    const indexesOpenArray: number[] = [
      dtTimeOpenIndex,
      drTimeOpenIndex,
    ].filter(elem => elem > 0);

    const dropdownTimesDrDt = [...dropdownTimes, ...specialDrDtTimes];
    const dtTimeCloseIndex = dropdownTimesDrDt.findIndex(
      (elem, index) => index > dtTimeOpenIndex && elem === dtTimeClose,
    );
    const drTimeCloseIndex = dropdownTimesDrDt.findIndex(
      (elem, index) => index > drTimeOpenIndex && elem === drTimeClose,
    );
    const indexesCloseArray: number[] = [
      dtTimeCloseIndex,
      drTimeCloseIndex,
    ].filter(elem => elem > 0);

    const minIndex = Math.min(...indexesOpenArray);

    if (isCalculated === 'Y') {
      if (indexesOpenArray.length) {
        if (deliveryHours) {
          if (
            deliveryHours.brand === brand &&
            deliveryHours.country === CountryId
          ) {
            if (dtIsOpened24Hours === 'Y' || drIsOpened24Hours === 'Y') {
              if (deliveryHours.default24HourTimeOpen !== null) {
                deliveryOpenTemp = deliveryHours.default24HourTimeOpen;
              } else {
                deliveryOpenTemp = '00:00';
              }
            } else {
              deliveryOpenTemp = calculateDeliveryTimeBase(
                dropdownTimes[minIndex],
                deliveryHours.opening,
                true,
              );
            }
          } else {
            deliveryOpenTemp = dropdownTimes[minIndex];
          }
        } else {
          deliveryOpenTemp = dropdownTimes[minIndex];
        }
      }
      setDeliveryOpen(deliveryOpenTemp);
      dispatch(
        setOperationHour({
          hourName: 'deliveryTimeOpen',
          hourValue: deliveryOpenTemp,
        }),
      );
    } else {
      setDeliveryOpen(deliveryTimeOpen ? deliveryTimeOpen : '');
    }

    if (isCalculated === 'Y') {
      if (indexesCloseArray.length) {
        const minIndexCloseArrays = Math.min(...indexesCloseArray);
        let maxIndex = Math.max(...indexesCloseArray);

        let maxCloseTime = moment(dropdownTimesDrDt[maxIndex], 'HH:mm');
        let minCloseTime = moment(
          dropdownTimesDrDt[minIndexCloseArrays],
          'HH:mm',
        );
        let minOpenTime = moment(dropdownTimes[minIndex], 'HH:mm');

        if (maxCloseTime.isSameOrBefore(minCloseTime)) {
          minCloseTime = maxCloseTime;
        }

        if (
          (minCloseTime.isAfter(minOpenTime) ||
            minCloseTime.isSameOrAfter(moment('06:00', 'HH:mm'))) &&
          minIndexCloseArrays > minIndex &&
          (maxIndex >= 51 || !maxCloseTime.isValid())
        ) {
          maxIndex = minIndexCloseArrays;
        }

        if (deliveryHours) {
          if (
            deliveryHours.brand === brand &&
            deliveryHours.country === CountryId
          ) {
            if (dtIsOpened24Hours === 'Y' || drIsOpened24Hours === 'Y') {
              if (deliveryHours.default24HourTimeClose !== null) {
                deliveryCloseTemp = deliveryHours.default24HourTimeClose;
              } else {
                deliveryCloseTemp = '00:00';
              }
            } else {
              deliveryCloseTemp = calculateDeliveryTimeBase(
                dropdownTimesDrDt[maxIndex],
                deliveryHours.closing,
                false,
              );
            }
          } else {
            deliveryCloseTemp = dropdownTimesDrDt[maxIndex];
          }
        } else {
          deliveryCloseTemp = dropdownTimesDrDt[maxIndex];
        }
      }
      setDeliveryClose(deliveryCloseTemp);
      dispatch(
        setOperationHour({
          hourName: 'deliveryTimeClose',
          hourValue: deliveryCloseTemp,
        }),
      );
    } else {
      setDeliveryClose(deliveryTimeClose ? deliveryTimeClose : '');
    }
  }, [drTimeOpen, dtTimeOpen, drTimeClose, dtTimeClose, drIsOpened24Hours, drIsClosed, dtIsOpened24Hours, dtIsClosed, dhIsOpened24Hours, brand, dispatch, deliveryHours, deliveryTimeOpen, deliveryTimeClose, isCalculated, CountryId]);

  const { t } = useTranslation();
  const tabletAppBar = (
    <div>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar variant="dense">
          <Grid container lg={12} direction="row">
            <Grid item lg={4} xs={4} style={{ margin: 'auto' }}>
              <Typography>{t('operationHours.timetable')}</Typography>
            </Grid>
            <Grid item lg={1} xs={2}>
              <div className={classes.tableCheckbox}>
                <div>
                  <Typography style={{ padding: 0 }}>
                    24<small>hrs</small>
                  </Typography>
                  <Checkbox
                    checked={checkedAllTF}
                    onChange={handleCheckAllTF}
                    style={{ color: 'white', padding: 0 }}
                    disabled={!hasEditPermission}
                  />
                </div>
                &nbsp;
                <div>
                  <Typography style={{ padding: 0 }}>
                    {t('operationHours.close')}
                  </Typography>
                  <Checkbox
                    checked={checkedAllClose}
                    onChange={handleCheckAllClose}
                    style={{ color: 'white', padding: 0 }}
                    disabled={!hasEditPermission}
                  />
                </div>
              </div>
            </Grid>
            <Grid item lg={6} xs={1} style={{ margin: 'auto' }}></Grid>
            <Grid
              item
              lg={6}
              xs={4}
              className={classes.tabletWeekdaysSelection}
            >
              <WeekDaysSelection targetReducer="OperationHoursReducer" />
            </Grid>
            <Grid item lg={6} xs={1} style={{ margin: 'auto' }}></Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );
  const desktopAppBar = (
    <div>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar variant="dense">
          <Grid container lg={12}>
            <Grid item lg={4} xs={4} style={{ margin: 'auto' }}>
              <Typography>{t('operationHours.timetable')}</Typography>
            </Grid>
            <Grid item lg={2} xs={1}>
              <div className={classes.desktopCheckbox}>
                <div className={classes.desktopCheckboxControl}>
                  <Typography style={{ padding: 0 }}>
                    <small>{t('app.common.twentyFourHour')}</small>
                  </Typography>
                  <Checkbox
                    checked={checkedAllTF}
                    onChange={handleCheckAllTF}
                    style={{ color: 'white', padding: 0 }}
                    disabled={!hasEditPermission}
                  />
                </div>
                &nbsp;
                <div className={classes.desktopCheckboxControl}>
                  {' '}
                  <Typography style={{ padding: 0 }}>
                    {' '}
                    <small> {t('operationHours.closed')}</small>
                  </Typography>
                  <Checkbox
                    checked={checkedAllClose}
                    onChange={handleCheckAllClose}
                    style={{ color: 'white', padding: 0 }}
                    disabled={!hasEditPermission}
                  />
                </div>
              </div>
            </Grid>
            <Grid item lg={1} xs={4} style={{ margin: 'auto' }}></Grid>
            <Grid
              item
              lg={4}
              xs={4}
              className={classes.desktopWeekdaysSelection}
            >
              <WeekDaysSelection targetReducer="OperationHoursReducer" />
            </Grid>
            <Grid item lg={1} xs={4} style={{ margin: 'auto' }}></Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div>
  );

  return (
    <React.Fragment>
      <Grid item xs={9} lg={3}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar variant="dense">
            <Typography>{t('operationHours.routineDaysAppBar')}</Typography>
          </Toolbar>
        </AppBar>
        <Paper className={classes.paper2}>
          <RoutineDaysWeekSelection
            targetReducer={'RoutineDaysReducer'}
            targetName={'deliveryDays'}
            title={t('operationHours.deliveryDays')}
            hasEditPermission={hasEditPermission}
          />
        </Paper>
      </Grid>
      <Grid item xs={12} lg={6}>
        {matches ? desktopAppBar : tabletAppBar}
        <Paper className={classes.paper2}>
          <ZoneListItem
            primary={t('operationHours.storeArrival')}
            firstTName={t('operationHours.specialEventArrival')}
            checked={checkedCB}
            checkedClose={checkedClose}
            handleChecked={setCheckedCB}
            handleCheckedClose={setCheckedClose}
            index={5}
            times={arrivalTimes}
            startTime={arrivalTime}
            startTimeName={varToString({ arrivalTime })}
            setEdited={setEdited}
            hasEditPermission={hasEditPermission}
          />

          {brand === 'TH' && (Region === 'NA' || !id) && (
            <ZoneListItem
              primary={t('operationHours.storeDeparture')}
              firstTName={t('operationHours.specialEventDeparture')}
              checked={checkedCB}
              checkedClose={checkedClose}
              handleChecked={setCheckedCB}
              handleCheckedClose={setCheckedClose}
              index={5}
              times={arrivalTimes}
              startTime={departureTime}
              startTimeName={varToString({ departureTime })}
              setEdited={setEdited}
              hasEditPermission={hasEditPermission}
            />
          )}

          <ZoneListItem
            primary={t('operationHours.diningRoom')}
            firstTName={t('operationHours.start')}
            secondTName={t('operationHours.finish')}
            checked={checkedCB}
            checkedClose={checkedClose}
            handleChecked={setCheckedCB}
            handleCheckedClose={setCheckedClose}
            index={0}
            startTime={drTimeOpen}
            startTimeMode={drTimeOpenMode}
            endTime={drTimeClose}
            endTimeMode={drTimeCloseMode}
            startTimeName={varToString({ drTimeOpen })}
            endTimeName={varToString({ drTimeClose })}
            twentyFourHourName={varToString({ drIsOpened24Hours })}
            closeHourName={varToString({ drIsClosed })}
            setEdited={setEdited}
            hasCheckboxes={true}
            times={arrivalTimes}
            hasEditPermission={hasEditPermission}
          />
          {
            driveThruService && driveThruService.value ?
          <ZoneListItem
            primary={t('operationHours.driveThru')}
            firstTName={t('operationHours.start')}
            secondTName={t('operationHours.finish')}
            checked={checkedCB}
            checkedClose={checkedClose}
            handleChecked={setCheckedCB}
            handleCheckedClose={setCheckedClose}
            index={1}
            startTime={dtTimeOpen}
            startTimeMode={dtTimeOpenMode}
            endTime={dtTimeClose}
            endTimeMode={dtTimeCloseMode}
            startTimeName={varToString({ dtTimeOpen })}
            endTimeName={varToString({ dtTimeClose })}
            twentyFourHourName={varToString({ dtIsOpened24Hours })}
            closeHourName={varToString({ dtIsClosed })}
            setEdited={setEdited}
            hasCheckboxes={true}
            times={arrivalTimes}
            hasEditPermission={hasEditPermission}
          /> : null
        }
          <ZoneListItem
            primary={t('operationHours.deliveryTime')}
            firstTName={t('operationHours.start')}
            secondTName={t('operationHours.finish')}
            isDisabled={isCalculated === 'Y'}
            enableDhTime24hr={
              (isCalculated === 'N' &&
                brand === 'BK' &&
                Region === 'NA' &&
                Country === 'Canada' &&
                CountryId === 36) || (
                isCalculated === 'N' &&
                brand === 'BK' && !id
              )
            }
            checked={checkedCB}
            checkedClose={checkedClose}
            handleChecked={setCheckedCB}
            handleCheckedClose={setCheckedClose}
            index={2}
            tooltipTitle={
              isCalculated === 'Y'
                ? t('operationHours.isCalculatedMessage')
                : ''
            }
            startTime={deliveryOpen}
            startTimeMode={deliveryTimeOpenMode}
            endTime={deliveryClose}
            endTimeMode={deliveryTimeCloseMode}
            twentyFourHourName={varToString({ dhIsOpened24Hours })}
            startTimeName={varToString({ deliveryTimeOpen })}
            endTimeName={varToString({ deliveryTimeClose })}
            setEdited={setEdited}
            hasCheckboxes={(isCalculated === 'N' &&
              brand === 'BK' &&
              Region === 'NA' &&
              Country === 'Canada' &&
              CountryId === 36) || (
                isCalculated === 'N' &&
                brand === 'BK' && !id
              )
            }
            times={arrivalTimes}
            hasEditPermission={hasEditPermission}
          />
          {
            cateringService && cateringService.value ?
              <ZoneListItem
                primary={t('operationHours.cateringTime')}
                firstTName={t('operationHours.start')}
                secondTName={t('operationHours.finish')}
                checked={checkedCB}
                checkedClose={checkedClose}
                handleChecked={setCheckedCB}
                handleCheckedClose={setCheckedClose}
                index={3}
                startTime={cateringTimeOpen}
                startTimeMode={cateringTimeOpenMode}
                endTime={cateringTimeClose}
                endTimeMode={cateringTimeCloseMode}
                startTimeName={varToString({ cateringTimeOpen })}
                endTimeName={varToString({ cateringTimeClose })}
                setEdited={setEdited}
                times={arrivalTimes}
                hasEditPermission={hasEditPermission}
              /> : null
          }
          {
            curbsideService && curbsideService.value ?
              <ZoneListItem
                primary={t('operationHours.curbsideTime')}
                firstTName={t('operationHours.start')}
                secondTName={t('operationHours.finish')}
                checked={checkedCB}
                checkedClose={checkedClose}
                handleChecked={setCheckedCB}
                handleCheckedClose={setCheckedClose}
                index={4}
                startTime={curbsideTimeOpen}
                startTimeMode={curbsideTimeOpenMode}
                endTime={curbsideTimeClose}
                endTimeMode={curbsideTimeCloseMode}
                startTimeName={varToString({ curbsideTimeOpen })}
                endTimeName={varToString({ curbsideTimeClose })}
                setEdited={setEdited}
                times={arrivalTimes}
                hasEditPermission={hasEditPermission}
              /> : null
          }
          <ZoneListItem
            primary={t('operationHours.breakfastTime')}
            secondary={t('operationHours.daypart')}
            isDayPart={true}
            firstTName={t('operationHours.start')}
            secondTName={t('operationHours.finish')}
            checked={checkedCB}
            checkedClose={checkedClose}
            handleChecked={setCheckedCB}
            handleCheckedClose={setCheckedClose}
            index={5}
            startTime={breakfastTimeOpen}
            startTimeMode={breakfastTimeOpenMode}
            endTime={breakfastTimeClose}
            endTimeMode={breakfastTimeCloseMode}
            startTimeName={varToString({ breakfastTimeOpen })}
            endTimeName={varToString({ breakfastTimeClose })}
            setEdited={setEdited}
            times={arrivalTimes}
            hasEditPermission={hasEditPermission}
          />
          <ZoneListItem
            primary={t('operationHours.lunchTime')}
            secondary={t('operationHours.daypart')}
            isDayPart={true}
            firstTName={t('operationHours.start')}
            secondTName={t('operationHours.finish')}
            checked={checkedCB}
            checkedClose={checkedClose}
            handleChecked={setCheckedCB}
            handleCheckedClose={setCheckedClose}
            index={6}
            startTime={lunchTimeOpen}
            startTimeMode={lunchTimeOpenMode}
            endTime={lunchTimeClose}
            endTimeMode={lunchTimeCloseMode}
            startTimeName={varToString({ lunchTimeOpen })}
            endTimeName={varToString({ lunchTimeClose })}
            setEdited={setEdited}
            times={arrivalTimes}
            hasEditPermission={hasEditPermission}
          />
          <ZoneListItem
            primary={t('operationHours.snackTime')}
            secondary={t('operationHours.daypart')}
            isDayPart={true}
            firstTName={t('operationHours.start')}
            secondTName={t('operationHours.finish')}
            checked={checkedCB}
            checkedClose={checkedClose}
            handleChecked={setCheckedCB}
            handleCheckedClose={setCheckedClose}
            index={7}
            startTime={snackTimeOpen}
            startTimeMode={snackTimeOpenMode}
            endTime={snackTimeClose}
            endTimeMode={snackTimeCloseMode}
            startTimeName={varToString({ snackTimeOpen })}
            endTimeName={varToString({ snackTimeClose })}
            setEdited={setEdited}
            times={arrivalTimes}
            hasEditPermission={hasEditPermission}
          />
          <ZoneListItem
            primary={t('operationHours.dinnerTime')}
            secondary={t('operationHours.daypart')}
            isDayPart={true}
            firstTName={t('operationHours.start')}
            secondTName={t('operationHours.finish')}
            checked={checkedCB}
            checkedClose={checkedClose}
            handleChecked={setCheckedCB}
            handleCheckedClose={setCheckedClose}
            index={8}
            startTime={dinnerTimeOpen}
            startTimeMode={dinnerTimeOpenMode}
            endTime={dinnerTimeClose}
            endTimeMode={dinnerTimeCloseMode}
            startTimeName={varToString({ dinnerTimeOpen })}
            endTimeName={varToString({ dinnerTimeClose })}
            setEdited={setEdited}
            times={arrivalTimes}
            hasEditPermission={hasEditPermission}
          />
          <ZoneListItem
            primary={t('operationHours.lateNight')}
            secondary={t('operationHours.daypart')}
            isDayPart={true}
            firstTName={t('operationHours.start')}
            secondTName={t('operationHours.finish')}
            checked={checkedCB}
            checkedClose={checkedClose}
            handleChecked={setCheckedCB}
            handleCheckedClose={setCheckedClose}
            index={9}
            startTime={lateNightTimeOpen}
            startTimeMode={lateNightTimeOpenMode}
            endTime={lateNightTimeClose}
            endTimeMode={lateNightTimeCloseMode}
            startTimeName={varToString({ lateNightTimeOpen })}
            endTimeName={varToString({ lateNightTimeClose })}
            setEdited={setEdited}
            times={arrivalTimes}
            hasEditPermission={hasEditPermission}
          />
        </Paper>
        <div>
          <Grid
            container
            direction="row"
            justify="flex-end"
            style={{ marginTop: 8 }}
          >
            <Grid item lg={2} xs={2} md={2} sm={2} xl={2}>
              <Button
                disabled={hasEditPermission && (weekDays.length && enableBtnEdited || weekDays.length && isEdited) ? false : true}
                variant="contained"
                color="primary"
                onClick={handleEditionCancel}
                style={{ marginRight: 10 }}
              >
                {t('app.common.cancel')}
              </Button>
            </Grid>
            <Grid item lg={2} xs={2} md={2} sm={2} xl={2}>
              <Button
                disabled={hasEditPermission && ((weekDays.length && enableBtnEdited || weekDays.length && isEdited) && (id || (!id && selectedRestaurants.length))) ? false : true}
                variant="contained"
                color="primary"
                onClick={handleEditionSubmit}
              >
                {t('app.common.save')}
              </Button>
            </Grid>
          </Grid>
        </div>
      </Grid>
      {successPopupModal.isOpen && <RBISuccessPopup isOpen={successPopupModal.isOpen} closeModal={handleSuccessCloseModal}
        message={successPopupModal.message} />}
      {openErrorModal && <ShowErrorMessageModal isOpen={openErrorModal} onClose={() => setOpenErrorModal(false)} errors={uploadErrors} />}
    </React.Fragment>
  );
}

export default BaseAdjustment;
